import config from "./config";
import {toast} from "react-toastify";

function rejectError(response, reject) {
    return response.text().then(text => {
        try {
            let status = "500";
            if (response) {
                if (response.status) {
                    if (!isNaN(Number(response.status.toString().trim()))) {
                        status = response.status.toString().trim();
                    }
                }
            }
            if (["401", "403"].includes(status)) {
                try {
                    toast.error("دسترسی رد شد!", {autoClose: 4500});
                } catch (err) {
                }
                try {
                    if (typeof localStorage !== "undefined") {
                        if (localStorage.getItem("token")) {
                            localStorage.removeItem("token");
                        }
                    }
                } catch (err) {
                }
                try {
                    setTimeout(() => {
                        if (typeof document !== "undefined") {
                            if (document.location.pathname !== "/login") {
                                document.location.href = "/login";
                            }
                        }
                    }, 4300);
                } catch (err) {

                }
            }
        } catch (err) {
        }
        let errorJson = {message: "خطا!", error: "خطا!"};
        try {
            errorJson = JSON.parse(text);
        } catch (err) {
        }
        reject(errorJson);
    });
}

export default {
    getRequest: (url = "") => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await fetch(url, {
                    method: "GET",
                    headers: {
                        "authorization": config.token
                    }
                });
                if (!response.ok) {
                    return rejectError(await response, reject);
                }
                await resolve(await response.json());
            } catch (error) {
                reject(error);
            }
        })

    },
    postRequest: (url = "", body = null) => {
        return new Promise(async (resolve, reject) => {
            try {
                let opt = {
                    method: "POST",
                }
                if (body) {
                    opt = {
                        ...opt,
                        headers: {
                            "Content-Type": "application/json",
                            "authorization": config.token
                        },
                        body: JSON.stringify(body)
                    }
                }
                const response = await fetch(url, opt);
                if (!response.ok) {
                    return rejectError(await response, reject);
                }
                await resolve(await response.json());
            } catch (error) {
                reject(error);
            }
        });
    },
    putRequest: (url = "", body = null) => {
        console.log(body);

        return new Promise(async (resolve, reject) => {
            try {
                let opt = {
                    method: "PUT",
                }
                if (body) {
                    opt = {
                        ...opt,
                        headers: {
                            "Content-Type": "application/json",
                            "authorization": config.token
                        },
                        body: JSON.stringify(body)
                    }
                }
                const response = await fetch(url, opt);
                console.log("res: ", response);
                if (!response.ok) {
                    return rejectError(await response, reject);
                }

                await resolve(await response.json());

            } catch (error) {
                console.error(error);
                reject(error);
            }

        })

    },
    deleteRequest: (url = "") => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await fetch(url, {
                    method: "DELETE",
                    headers: {
                        "authorization": config.token
                    }
                });
                if (!response.ok) {
                    return rejectError(await response, reject);
                }
                await resolve(await response.json());
            } catch (error) {
                reject(error);
            }
        });
    }
}